/* eslint-disable */
// @ts-nocheck

import {
  IDropdownOption,
  IDropdownTableHeader,
} from '@/components/new/table/header/components/DropdownTableHeader'

export interface ITextTableHeader {
  type: 'text'
  label: string
}
type Props = Omit<ITextTableHeader, 'type'>

export const TextTableHeader = ({ label }: Props) => {
  return <h2 className={'text-lg font-bold'}>{label}</h2>
}
